import Dropdown from 'ageas-react-component-dropdownlist'

import TextField from 'ageas-react-component-textfield'
import { useState } from 'react'
import { useAnimalStore } from '../../Stores/animalStore'
import { useFillDataForSimulationStore } from '../../Stores/useFillDataForSimulationStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useResumeStore } from '../../Stores/useResumeStore'
import { AnimalsSecured } from '../../Types/AnimalStore'
import { t } from '../../i18n'
import { validateNumberAndLetters } from '../../utils/validates'
import { GeralDataContainer, Title } from './style'

type AnimalTabGeneralDataProps = {
  animal: AnimalsSecured
}

export const AnimalTabGeneralData = ({ animal }: AnimalTabGeneralDataProps) => {
  const { updateAnimal } = useAnimalStore()
  const [pristineAnimalLicenseNumber, setPristineAnimalLicenseNumber] =
    useState(false)
  const [pristineAnimalChipNumber, setPristineAnimalChipNumber] =
    useState(false)
  const { isGenerateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { disabledStepsByResume } = useResumeStore()

  const updateAnimalRiskData = (value: { [key: string]: string }) => {
    updateAnimal(value, animal.id)
  }

  const { fillDataForSimulationRequest } = useFillDataForSimulationStore()

  const animalLicenseNumberMessage = () => {
    const animalLicenseNumberLength = (animal.licenseNumber || '').length

    if (
      animalLicenseNumberLength > 0 &&
      !validateNumberAndLetters(animal.licenseNumber || '')
    ) {
      return {
        message: t('pages.step4.animalLicenseNumberError'),
        isError: true,
      }
    }

    if (validateNumberAndLetters(animal.licenseNumber || '')) {
      return {
        message: '',
        isError: false,
      }
    }

    return {
      message: t('pages.step4.mandatoryField'),
      isError: false,
    }
  }

  const animalChipNumberMessage = () => {
    const animalChipNumberLength = (animal.chipNumber || '').length

    if (animalChipNumberLength > 16) {
      updateAnimalRiskData({ chipNumber: '' })
      return {
        message: t('pages.step4.characterLimit'),
        isError: true,
      }
    }

    if (
      animalChipNumberLength > 0 &&
      !validateNumberAndLetters(animal.chipNumber || '')
    ) {
      return {
        message: t('pages.step4.animalLicenseNumberError'),
        isError: true,
      }
    }

    if (validateNumberAndLetters(animal.chipNumber || '')) {
      return {
        message: '',
        isError: false,
      }
    }

    return {
      message: t('pages.step4.mandatoryField'),
      isError: false,
    }
  }

  const formatGenderOptions = () => {
    return (
      fillDataForSimulationRequest?.petDetailsResponse?.petGenderList || []
    )?.map((gender) => {
      return {
        caption: gender?.shortDescription,
        value: gender?.code,
      }
    })
  }

  return (
    <GeralDataContainer>
      <Title>{t('pages.step4.insuredDataAnimal')}</Title>
      <div className="row">
        <div className="col">
          <Dropdown
            required
            readOnly={
              isGenerateProposalDocuments || disabledStepsByResume.step4
            }
            id={'animalGender' + animal.name}
            name={'animalGender' + animal.name}
            label={t('pages.step4.gender')}
            value={animal.gender || ''}
            version="2"
            onValueChanged={(id: any, value: string) => {
              if (
                formatGenderOptions()
                  .map((option) => option.value)
                  .includes(value)
              ) {
                updateAnimalRiskData({ gender: value })
              } else {
                updateAnimalRiskData({ gender: '' })
              }
            }}
            colorTheme="blue"
            options={formatGenderOptions()}
          />
          <TextField
            readOnly={
              isGenerateProposalDocuments || disabledStepsByResume.step4
            }
            messageType={
              animalLicenseNumberMessage().isError ? 'error' : 'warning'
            }
            message={animalLicenseNumberMessage().message}
            id={`animalLicenseNumber${pristineAnimalLicenseNumber}-${animal.id}`}
            key={`animalLicenseNumber${animal.id}-${animal.id}`}
            name="animalLicenseNumber"
            label={t('pages.step4.licenseNumber')}
            value={animal.licenseNumber}
            colorTheme="blue"
            maxLength={30} //TODO: Not present in requirements, review
            version="2"
            onValueChanged={(id: string, value: string) => {
              setPristineAnimalLicenseNumber(true)
              updateAnimalRiskData({ licenseNumber: value })
            }}
          />
        </div>
        <div className="col">
          <TextField
            readOnly={
              isGenerateProposalDocuments || disabledStepsByResume.step4
            }
            messageType={
              animalChipNumberMessage().isError ? 'error' : 'warning'
            }
            message={animalChipNumberMessage().message}
            id={`chipNumber${pristineAnimalChipNumber}-${animal.id}`}
            key={`chipNumber${pristineAnimalChipNumber}-${animal.id}`}
            name="animalChipNumber"
            label={t('pages.step4.chipNumber')}
            value={animal.chipNumber}
            colorTheme="blue"
            maxLength={15}
            version="2"
            onValueChanged={(id: string, value: string) => {
              setPristineAnimalChipNumber(true)
              updateAnimalRiskData({ chipNumber: value })
            }}
          />
        </div>
      </div>
    </GeralDataContainer>
  )
}
